<template>
  <router-view />
</template>

<script setup>
import {onMounted, onUnmounted} from 'vue'

onMounted(() => {
  const body = document.body
  body.classList.add('black')
})

onUnmounted(() => {
  const body = document.body
  body.classList.remove('black')
})
</script>
